import { Card, CardSection, Group, Skeleton, Stack } from '@mantine/core';

export default function CardSkeleton() {
  return (
    <Card shadow='md' py='lg'>
      <CardSection withBorder inheritPadding pt='xs' pb='sm'>
        <Group wrap='nowrap'>
          <Skeleton
            height={36}
            width={36}
            style={{ display: 'inline-block' }}
            radius='xl'
          />
          <Stack gap={0} justify='center' w='90%'>
            <Skeleton height={12} width='30%' />
            <Skeleton height={10} mt={6} width='25%' />
          </Stack>
        </Group>
      </CardSection>
      <CardSection inheritPadding py='xs'>
        <Group wrap='nowrap'>
          <Skeleton height={12} my={6} width='40%' />
          <Skeleton height={12} my={6} width='35%' />
        </Group>
        <Skeleton height={10} />
        <Skeleton height={10} my={6} />
        <Skeleton height={10} my={6} width='70%' />
      </CardSection>
    </Card>
  );
}
